import { create } from "zustand";
import type { UserRole } from "@mersa/shared";

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  role: UserRole;
  emailVerifiedAt: string | null;
}

interface AuthState {
  accessToken: string | null;
  user: CurrentUser | null;
  /** AuthInit refresh denemesini tamamlayınca true olur. Sayfa yenilemede /giris'e hızlı yönlendirmeyi önler. */
  authReady: boolean;
  setToken: (token: string | null) => void;
  setUser: (user: CurrentUser | null) => void;
  setAuthReady: (ready: boolean) => void;
  clear: () => void;
}

/** Access JWT'den sub (user id) — refresh sırasında aynı kullanıcıyı korumak için. */
function accessTokenSub(token: string | null): string | null {
  if (!token) return null;
  try {
    const b64 = (token.split(".")[1] || "").replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64)) as { sub?: unknown };
    return typeof payload.sub === "string" ? payload.sub : null;
  } catch {
    return null;
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  authReady: false,
  // Refresh aynı kullanıcıysa user kalsın (FreeQuiz vb. "çıkış" sanmasın).
  // Farklı kullanıcı login olursa eski user temizlenir — useMe/setUser doldurur.
  setToken: (accessToken) =>
    set((state) => {
      if (!accessToken) return { accessToken: null, user: null };
      const nextSub = accessTokenSub(accessToken);
      if (state.user && nextSub && state.user.id === nextSub) {
        return { accessToken };
      }
      if (state.user && nextSub && state.user.id !== nextSub) {
        return { accessToken, user: null };
      }
      return { accessToken };
    }),
  setUser: (user) => set({ user }),
  setAuthReady: (authReady) => set({ authReady }),
  clear: () => set({ accessToken: null, user: null }),
}));
